import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'
import { Icon } from '@/components/ui/Icon'
import { describeError } from '@/components/ui/error-copy'
import { ApiError } from '@/lib/api/problem'
import { cn } from '@/lib/cn'

type ErrorStateProps = {
  error: unknown
  onRetry?: () => void
  className?: string
}

export function ErrorState({ error, onRetry, className }: ErrorStateProps) {
  const { t } = useTranslation()
  const copy = describeError(error)
  const correlationId = error instanceof ApiError ? error.correlationId : null

  return (
    <div
      role="alert"
      className={cn(
        'panel flex flex-col items-center gap-3 rounded-lg px-6 py-10 text-center',
        className,
      )}
    >
      <span className="inline-flex size-control-md items-center justify-center rounded-full bg-error-surface text-error-strong">
        <Icon name="alertTriangle" className="size-6" />
      </span>

      <h2 className="text-base font-semibold text-ink">{t(copy.title)}</h2>
      <p className="max-w-prose text-sm text-ink-muted">{t(copy.description)}</p>

      {correlationId === null ? null : (
        <p className="font-mono text-xs text-ink-muted">
          {`${t('errors.correlationId')}: ${correlationId}`}
        </p>
      )}

      {onRetry === undefined ? null : (
        <Button variant="secondary" icon="refresh" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      )}
    </div>
  )
}
